<div class="popup">
    <div class="header">
        <h2>{{existingLeague ? 'Update' : 'Create'}} Season</h2>
        <button mat-icon-button (click)="onNoClick()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="text-center">
        <div class="Container">
            <form #formData="ngForm">
                <p-card header="Enter Season Details" [style]="{width: '500px', marginBottom: '50px'}" class="Container1 mt-5">
                    <div class="field">
                        <label for="leaguename">Season Name</label>
                        <input id="leaguename" pInputText class="w-full" type="text" name="leaguename"
                            placeholder="Enter your leaguename" [(ngModel)]="league.name" required>
                    </div>

                    <div class="field">
                        <label for="minimumAge">Minimum Age</label>
                        <input id="minimumAge" pInputText class="w-full" type="number" name="minimumAge"
                            placeholder="Enter Minimum Age" [(ngModel)]="league.minimumAge" required>
                    </div>

                    <div class="field">
                        <label for="rating">USTA Rating</label>
                        <input id="rating" pInputText class="w-full" type="text" name="rating"
                            placeholder="Enter Usta Rating" [(ngModel)]="league.rating" required>
                    </div>

                    <div class="field">
                        <label for="registrationStartDate">Registration Start Date</label>
                        <input id="registrationStartDate" pInputText class="w-full" type="date"
                            name="registrationStartDate" [(ngModel)]="league.registrationStartDate" required>
                    </div>

                    <div class="field">
                        <label for="registrationEndDate">Registration End Date</label>
                        <input id="registrationEndDate" pInputText class="w-full" type="date" name="registrationEndDate"
                            [(ngModel)]="league.registrationEndDate" required>
                    </div>

                    <div class="field">
                        <label for="startDate">Season Start Date</label>
                        <input id="startDate" pInputText class="w-full" type="date" name="startDate"
                            [(ngModel)]="league.startDate" required>
                    </div>

                    <div class="field">
                        <label for="endDate">Season End Date</label>
                        <input id="endDate" pInputText class="w-full" type="date" name="endDate"
                            [(ngModel)]="league.endDate" required>
                    </div>

                    <div class="field">
                        <label for="playoff">Playoff</label>
                        <input id="playoff" type="checkbox" name="playoff" [(ngModel)]="league.playoff">
                    </div>

                    <div class="field" *ngIf="league.playoff">
                        <label for="playoffStartDate">Playoff Start Date</label>
                        <input id="playoffStartDate" pInputText class="w-full" type="date" name="playoffStartDate"
                            [(ngModel)]="league.playoffStartDate">
                    </div>

                    <div class="field" *ngIf="league.playoff">
                        <label for="playoffEndDate">Playoff End Date</label>
                        <input id="playoffEndDate" pInputText class="w-full" type="date" name="playoffEndDate"
                            [(ngModel)]="league.playoffEndDate">
                    </div>

                    <div class="field">
                        <label for="leagueType">Season Type</label>
                        <select id="leagueType" pInputText class="w-full" name="leagueType" (change) = "leagueTypeChange()"
                            [(ngModel)]="league.leagueType">
                            <option value="S">Singles</option>
                            <option value="D">Doubles</option>
                            <option value="T">Team</option>
                        </select>
                    </div>

                    <div class="field">
                        <label for="teamSize">Team Size</label>
                        <input id="teamSize" pInputText class="w-full" type="number" name="teamSize" [disabled]="league.leagueType == 'S' || league.leagueType == 'D' "
                            placeholder="Enter Team Size" [(ngModel)]="league.teamSize" required>
                    </div>

                    <div class="field">
                        <label for="gender">Gender</label>
                        <select id="gender" pInputText class="w-full" name="gender" [(ngModel)]="league.gender">
                            <option value="M">Mens</option>
                            <option value="W">Women</option>
                            <option value="X">Mixed</option>
                        </select>
                    </div>

                    <div class="field" *ngIf="league.leagueType === 'T' && league.gender === 'M'">
                        <label for="menSinglesCount">Mens Singles Count</label>
                        <input id="menSinglesCount" pInputText class="w-full" type="number" name="menSinglesCount"
                            [(ngModel)]="league.menSinglesCount">
                    </div>

                    <div class="field" *ngIf="league.leagueType === 'T' && league.gender === 'W'">
                        <label for="womenSinglesCount">Womens Singles Count</label>
                        <input id="womenSinglesCount" pInputText class="w-full" type="number" name="womenSinglesCount"
                            [(ngModel)]="league.womenSinglesCount">
                    </div>

                    <div class="field" *ngIf="league.leagueType === 'T' && league.gender === 'M'">
                        <label for="mensDoublesCount">Mens Doubles Count</label>
                        <input id="mensDoublesCount" pInputText class="w-full" type="number" name="mensDoublesCount"
                            [(ngModel)]="league.menDoublesCount">
                    </div>

                    <div class="field" *ngIf="league.leagueType === 'T' && league.gender === 'W'">
                        <label for="womenDoublesCount">Womens Doubles Count</label>
                        <input id="womenDoublesCount" pInputText class="w-full" type="number" name="womenDoublesCount"
                            [(ngModel)]="league.womenDoublesCount">
                    </div>

                    <div class="field" *ngIf="league.leagueType === 'T' && league.gender == 'X'" >
                        <label for="mixedDoublesCount">Mixed Doubles Count</label>
                        <input id="mixedDoublesCount" pInputText class="w-full" type="number" name="mixedDoublesCount"
                            [(ngModel)]="league.mixedDoublesCount">
                    </div>

                    <div class="field">
                        <label for="maxNumberOfTeams">Max Number of Teams</label>
                        <input id="maxNumberOfTeams" pInputText class="w-full" type="number" name="maxNumberOfTeams"
                            placeholder="Enter Max Number of Teams" [(ngModel)]="league.maxNumberOfTeams" required>
                    </div>

                    <div class="field">
                        <label for="fees">Registration Fees</label>
                        <input id="fees" pInputText class="w-full" type="number" name="fees"
                            placeholder="Enter Registration Fees" [(ngModel)]="league.fees" required>
                    </div>

                    <br>
                    <button type="submit" class="registerBtn" [disabled]="formData.invalid"
                        (click)="dialogRef.close(league)">
                        {{ existingLeague ? 'Update' : 'Create' }}
                    </button>
                </p-card>
            </form>
        </div>
    </mat-dialog-content>
</div>